import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-admin-budget-report',
  templateUrl: './admin-budget-report.component.html',
  styleUrls: ['./admin-budget-report.component.scss']
})
export class AdminBudgetReportComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
